// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const popoverClasses = {
  arrow: "qui-popover__arrow",
  arrowTip: "qui-popover__arrow-tip",
  closeTrigger: "qui-popover__close-trigger",
  content: "qui-popover__content",
  description: "qui-popover__description",
  indicator: "qui-popover__indicator",
  label: "qui-popover__label",
  trigger: "qui-popover__trigger",
} as const
